import React from 'react'
import './About.css'

const About = () => {
  return (
    <section id='about'>
        <div className='container'>
            <div className='titel'>
                <h2>About me</h2>
                <h3>About me</h3>
            </div>
            <div className='about-wrapper'>
                <div className='about-left'>
                    <p>my name is <span>mohcin charef</span> and i will <span>design and develop</span> the website that gonna help you <span>stand out</span> in your industry.</p>
                    <p>To see if I am a good fit for your needs, here are the different <span>services</span> i can provide for you :</p>
                    <ul>
                        <li>complete or partial website redesigns.</li>
                        <li>Totally new website designs.</li>
                        <li>website development ....</li>
                    </ul>
                    <a href='#contact' className='secondary-btn'>Contact</a>
                </div>
                <div className='about-img'>
                    <img src='./assets/about.jpg' />
                </div>
            </div>
        </div>
    </section>
  )
}

export default About